<template>
  <div>
    <v-snackbar class="snakbar-sty rounded-pill" transition="slide-x-reverse-transition" v-model="snackbar" :timeout="3000" :value="true" :color="snackbarclr" absolute outlined>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <div v-if="!mainloader" class="body-row pb-3 px-4 px-md-6 px-lg-8 pt-lg-6">
      <zebu-logo />
      <v-card class="elevation-0">
        <p class="mynt-eyebrow font-weight-bold mb-2">Welcome to Zebu</p>
        <p class="mynt-title font-weight-bold" :class="flowsso ? 'mb-4' : 'mb-7'">Login to {{ vcname }}</p>

        <div>
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
            <div v-if="flowsso">
              <!-- <p class="font-weight-medium fs-17 mb-0">
                Select your Vendor
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                  <path
                    d="M5.10423 0.5L4.85634 3.86901L7.95493 2.53944L8.56338 4.17324L5.13803 4.98451C5.30329 5.17981 5.48732 5.38638 5.69014 5.60423C5.89296 5.81455 6.09577 6.02864 6.29859 6.24648C6.50892 6.46432 6.71549 6.6784 6.91831 6.88873C7.12113 7.09906 7.30892 7.29437 7.48169 7.47465L6.12958 8.5L4.25916 5.6831L2.33239 8.5L0.991549 7.47465L3.35775 4.98451L0 4.12817L0.51831 2.53944L3.68451 3.88028L3.38028 0.5H5.10423Z"
                    fill="#EF5350"
                  />
                </svg>
              </p>
              <v-select append-icon="mdi-chevron-down" :items="ssoitems" v-model="ssois" class="mb-1"></v-select> -->
              <v-tabs fixed-tabs @change="sstTabtype()" height="40px" v-model="ssois">
                <v-tab class="text-none">MYNT</v-tab>
                <v-tab class="text-none">XTS</v-tab>
              </v-tabs>
              <v-divider class="mb-3"></v-divider>
            </div>
            <v-text-field v-model="userId" :disabled="loading" :rules="useridRules" color="#0037B7" class="mynt-field mb-3" label="Mobile / Client ID" required oninput="this.value = this.value.toUpperCase()"></v-text-field>

            <v-text-field
              v-model="password"
              :disabled="loading"
              :append-icon="pwseye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="pwsRules"
              :type="pwseye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              label="Password"
              @click:append="pwseye = !pwseye"
            ></v-text-field>

            <v-text-field
              v-model="twofact"
              :disabled="loading"
              :append-icon="twofacteye ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="ssois == 1 ? twofacteyeRulest : twofacteyeRules"
              :type="twofacteye ? 'text' : 'password'"
              color="#0037B7"
              class="mynt-field mb-3"
              :label="ssois == 1 ? 'PIN' : 'PAN/DOB/OTP'"
              @click:append="twofacteye = !twofacteye"
              required
              oninput="this.value = this.value.toUpperCase()"
            ></v-text-field>
            <div class="mt-4" :style="`cursor: ${valid != true ? 'not-allowed' : 'auto'};`">
              <v-btn height="47px" :disabled="!valid" :loading="loading" type="submit" color="#0037B7" class="text-none mynt-btn elevation-0 mb-1" block> <span class="white--text mynt-btn-label">Sign In</span></v-btn>
            </div>
            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="3" class="text-left pr-3">
                  <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="otpto()">
                    <span class="mynt-link text-none"> Get OTP </span>
                  </v-btn>
                </v-col>
                <v-col cols="9" class="text-right">
                  <v-list-item-title>
                    <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="forgotPws()">
                      <span class="mynt-link text-none"> Forgot password</span>
                    </v-btn></v-list-item-title
                  >
                </v-col>
              </v-row>
            </p>
          </v-form>
          <p class="mynt-signup mb-0 text-center mt-6">Don't have an account yet? <a class="mynt-link" style="text-decoration: none" href="https://oa.mynt.in?ref=desk">Sign Up</a></p>
        </div>
      </v-card>
      <v-footer padless absolute color="#fff">
        <v-col class="text-center font-weight-medium fs-13 px-lg-8 px-md-6 px-lg-8 pb-2 mynt-legal" cols="12"
          ><span class="font-weight-bold fs-14 black--text"> Zebu Share and Wealth Managements Pvt. Ltd. </span><br />
          SEBI Registration No: INZ000174634 | NSE : 13179 | BSE : 6550 | MCX : 55730 | CDSL : 12080400 | AMFI ARN : 113118 | Research Analyst : INH200006044
        </v-col>
      </v-footer>
    </div>
    <v-overlay :value="mainloader" opacity="1" color="transparent" class="rounded-0">
      <div class="text-center">
        <v-card width="70%" color="transparent" class="elevation-0 mx-auto">
          <v-progress-circular color="primary" :size="60" :width="4" indeterminate></v-progress-circular>
        </v-card>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import {sha256} from "js-sha256";
import { mynturl ,apikey , mynturltv, tvapikey, source, redurl, sessurl , newredurl} from "../../apiUrl.js";
import ZebuLogo from "../../components/ZebuLogo.vue";

export default {
  components: {ZebuLogo},

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    // signinform: true,
    valid: true,
    userId: "",
    useridRules: [(v) => !!v || "Client Id is required"],
    pwseye: false,
    password: "",
    pwsRules: [(v) => !!v || "Password is required"],

    twofacteye: false,
    twofact: "",
    twofacteyeRules: [
      (v) => !!v || "PAN/DOB/OTP is required",
      (v) => v.length >= 4 || "PAN/DOB/OTP of minimum 4 characters or must be valid",
      // v => /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || 'PAN number must be valid',
    ],
    twofacteyeRulest: [(v) => !!v || "PIN is required", (v) => v.length == 6 || "Enter your 6 digit PIN"],
    vcname: "MYNT",
    flowsso: false,

    // ssoitems: ["Mynt", 'XTS'],
    ssois: 0,

    loading: false,
    mainloader: true,
    routeid:"",
    instaopkey:""
  }),

  created() {
    var url = new URL(window.location.href);
    let vc = url.searchParams.get("vc");
    this.instaopkey = vc
    
    let key = url.searchParams.get("key");

    if (vc && key) {
      window.location.assign(`${ (vc == 'instaoptions' || vc == 'rupeecase' || vc == 'rupeecase_dev' || vc == 'nandiz' || vc == 'sigmascanner') ? newredurl : redurl }?vc=${vc}&key=${key}`);
      this.mainloader = true;
    } else {
      this.mainloader = false;
      if (vc == "instaoptions" || vc == "instaoptionsxts") {
        this.ssois = vc == "instaoptionsxts" ? 1 : 0;
        this.flowsso = true;
      } else {
        this.flowsso = false;
      }
      this.getBadges(vc);
    }
    this.getPublicIP();
  },

  mounted() {
      this.routeid = this.$route.query.session_id
    //
  },

  methods: {
     async getPublicIP() {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        localStorage.setItem("ipadd", data.ip);
      } catch (error) {
        console.error(error);
      }
    },
    validate() {
      this.$refs.form.validate();
      var shapass = sha256(this.password);
      var appkey = sha256(this.userId + apikey);
      var tvappkeynew = sha256(this.userId + tvapikey);

      if (this.$refs.form.validate()) {
        let cuuid = crypto.randomUUID();
        // let cuuid = "JDJDKJ-jhdeujhe-jkd";

        this.loading = true;
        var data = this.ssois == 1 ? {cc: this.userId, pass: btoa(this.password), pin: btoa(this.twofact)} : `jData={"uid":"${this.userId}","pwd":"${shapass}","factor2":"${this.twofact}","apkversion":"20220921","imei":"${cuuid}","addldivinf":"${navigator.appVersion}","ipaddr":"${localStorage.getItem("ipadd")}","vc":"PRO_MYNT","appkey":"${ this.instaopkey == 'instaoptions' ? tvappkeynew : appkey}","source":"${this.instaopkey == 'instaoptions' ? 'TV' : source}"}`;
        var config = {
          method: "post",
          url: this.ssois == 1 ? `${sessurl}/xtsLogin` : this.instaopkey == 'instaoptions' ? `${mynturltv}/QuickAuth` : `${mynturl}/QuickAuth`,
          headers: {
            "Content-Type": this.ssois == 1 ? "application/json" : "text/plain",
          },
          data: data,
        };
        var axiosThis = this;

        axios(config)
          .then(function (response) {
            let vc = new URL(window.location.href).searchParams.get("vc");

            if (axiosThis.ssois == 1) {
              if (response.data && response.data.stat == "Ok") {
                window.location.assign(`${redurl}?actid=${axiosThis.userId}&cliname=${response.data.name}&accessToken=${response.data.data.token}&vc=${vc}&imei=${cuuid}`);

                // axiosThis.snackbarclr = "success";
                // axiosThis.snackmsgbar = "Login successfully";
              } else {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#f23645";
                axiosThis.snackmsgbar = response.data && response.data.msg ? response.data.msg : response.data;
              }
            } else {
              if (response.data.susertoken && response.data.actid) {
                if (vc) {
                  if(axiosThis.routeid){
                  window.location.assign(`${redurl}?uid=${axiosThis.userId}&pwd=${encodeURIComponent(axiosThis.password)}&factor2=${axiosThis.twofact}&vc=${vc}&imei=${cuuid}&session_id=${axiosThis.routeid}`);
                  }
                  else{
                  window.location.assign(`${(axiosThis.instaopkey == 'instaoptions' || axiosThis.instaopkey == 'rupeecase' || axiosThis.instaopkey == 'rupeecase_dev' || axiosThis.instaopkey == 'nandiz' || axiosThis.instaopkey == 'sigmascanner') ? newredurl : redurl }?uid=${axiosThis.userId}&pwd=${encodeURIComponent(axiosThis.password)}&factor2=${axiosThis.twofact}&vc=${vc}&imei=${cuuid}`);
                  }
                }
                 else {
                  axiosThis.snackbar = true;
                  axiosThis.snackbarclr = "#f23645";
                  axiosThis.snackmsgbar = "Invalid url or Wrong url";
                }
              } else if (response.data.emsg == "Invalid Input : Invalid User") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#f23645";
                axiosThis.snackmsgbar = "Invalid User or Invalid Client ID";
                axiosThis.userId = "";
                axiosThis.password = "";
                axiosThis.twofact = "";
              } else if (response.data.emsg == "Invalid Input : Wrong Password") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = "Wrong Password.";
                axiosThis.password = "";
              } else if (response.data.emsg == "Invalid Input : Invalid OTP") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = "Invalid OTP.";
                axiosThis.twofact = "";
              } else if (response.data.emsg == "Invalid Input : Wrong PAN/DOB") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = "Wrong PAN/DOB number.";
                axiosThis.twofact = "";
              } else if (response.data.emsg == "Invalid Input : Deactivated") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = "Deactivated.";
                axiosThis.twofact = "";
              } else if (response.data.emsg == "Session Expired :  Invalid Session Key" || response.data.emsg == "Session Expired : Invalid Session Key") {
                axiosThis.snackbar = false;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = "Invalid Session Key.";
              } else if (response.data.emsg == "Invalid Input : Invalid Access Type") {
                axiosThis.snackbar = false;
                axiosThis.snackbarclr = "warning";
                axiosThis.snackmsgbar = " Invalid Access Type, Mismatch in API URL.";
              } else if (response.data.emsg == "Invalid Input : User Blocked due to multiple wrong attempts") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#f23645";
                axiosThis.snackmsgbar = "User Blocked due to multiple wrong attempts.";
                setTimeout(function () {
                  axiosThis.$router.push("/forgot_password");
                }, 2000);
              } else if (response.data.emsg == "Invalid Input : Change Password" || response.data.emsg == "Invalid Input : Password Expired") {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "warning";
                if (response.data.emsg == "Invalid Input : Change Password") {
                  axiosThis.snackmsgbar = "Password as Change, please set new Password.";
                } else if (response.data.emsg == "Invalid Input : Password Expired") {
                  axiosThis.snackmsgbar = "Password Expired, please Change Password.";
                }
                axiosThis.userId = "";
                axiosThis.password = "";
                axiosThis.twofact = "";
                setTimeout(function () {
                  axiosThis.$router.push("/change_password");
                }, 2000);
              } else {
                axiosThis.snackbar = true;
                axiosThis.snackbarclr = "#f23645";
                if (response.data.emsg) {
                  axiosThis.snackmsgbar = response.data.emsg;
                } else {
                  axiosThis.snackmsgbar = "something went wrong, Kindly Sign in.";
                }
                axiosThis.userautosave = axiosThis.knowautosave;
                let routrs = localStorage.getItem("routset");
                localStorage.clear();
                localStorage.setItem("routset", routrs);
                localStorage.setItem("autoSave", axiosThis.userautosave);
                axiosThis.userId = "";
                axiosThis.password = "";
                axiosThis.twofact = "";
              }
            }
            axiosThis.loading = false;
          })
          .catch(function (error) {
            console.log(error);
            axiosThis.loading = false;
            if (error.response.data.emsg) {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = error.response.data.emsg;
              axiosThis.userautosave = axiosThis.knowautosave;
              let routrs = localStorage.getItem("routset");
              localStorage.clear();
              localStorage.setItem("routset", routrs);
              localStorage.setItem("autoSave", axiosThis.userautosave);
            }
          });
      }
    },
    sstTabtype() {
      this.$router.push(`/?vc=${this.ssois == 0 ? "instaoptions" : "instaoptionsxts"}`);
      this.getBadges(this.ssois == 0 ? "instaoptions" : "instaoptionsxts");
    },
    getBadges(vc) {
      let config = {
        method: "get",
        url: `${sessurl}/get_vc_name?vc=${vc}`,
      };

      let axiosThis = this;
      axios
        .request(config)
        .then((res) => {
          if (res.data && res.data.name) {
            axiosThis.vcname = res.data.name;
          }
        })
        .catch((error) => {
          axiosThis.vcname = "MYNT";
          console.log(error);
        });
    },
    otpto() {
      this.$router.push("/OTP_sigin");
    },
    forgotPws() {
      this.$router.push("/forgot_password");
    },
  },
};
</script>

